import { createContext, useContext } from 'react';

export interface CanvasContextValue {
  /** The entity ID of the canvas being rendered. Used by shell components
   * (e.g. ConnectedEntityProxyNode) that need the canvas ID for API calls
   * but are rendered by React Flow and cannot receive it via direct props. */
  canvasId: string;
}

export const CanvasContext = createContext<CanvasContextValue | null>(null);

export function useCanvasContext(): CanvasContextValue {
  const ctx = useContext(CanvasContext);
  if (ctx === null) throw new Error('useCanvasContext used outside CanvasContext.Provider');
  return ctx;
}
